import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const fetchChatsInformationAction = createAsyncAction(
  '@chat/FETCH_CHATS_INFORMATION_REQUEST',
  '@chat/FETCH_CHATS_INFORMATION_SUCCESS',
  '@chat/FETCH_CHATS_INFORMATION_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingFetchChatsInformation: true
})

const success = (state: ChatState, action: ActionType<typeof fetchChatsInformationAction.success>): ChatState => {
  return {
    ...state,
    informations: action.payload.informations,
    isSuccessOnFetchChatsInformation: true,
    isLoadingFetchChatsInformation: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingFetchChatsInformation: false,
  isErrorOnFetchChatsInformation: true
})

export const fetchChatsInformationHandle = { asyncAction: fetchChatsInformationAction, request, success, failure }
